"use client"

import { Col, Row } from "antd";
import { FC } from "react";
import SelectDestinationSkeleton from "./SelectDestination.skeleton";
import SelectCheckInOutSkeleton from "./SelectCheckInOut.skeleton";
import SelectRoomAndPeopleSkeleton from "./SelectRoomAndPeople.skeleton";
import ButtonSearchHotelsSkeleton from "./ButtonSearchFlight.skeleton";

type SearchingHotelsSkeletonProps = {
  size?: 'default' | 'small'
}

const SearchingHotelsSkeleton: FC<SearchingHotelsSkeletonProps> = ({ size = 'default' }) => {
  const isSmall = size === 'small'
  const fieldSize = 'small' as const

  if (isSmall) {
    return (
      <div className="home__searching--hero-form home__searching--hotel-hero-form">
        <Row
          wrap={false}
          gutter={[12, 0]}
          align="bottom"
          className="home__searching--hero-row"
        >
          <Col flex="1.2 1 0" className="home__searching--hero-field-col">
            <SelectDestinationSkeleton size={fieldSize} />
          </Col>
          <Col
            flex="1.75 1 18rem"
            className="home__searching--hero-field-col home__searching--hero-dates-col"
          >
            <SelectCheckInOutSkeleton size={fieldSize} />
          </Col>
          <Col flex="1.15 1 0" className="home__searching--hero-field-col">
            <SelectRoomAndPeopleSkeleton size={fieldSize} />
          </Col>
          <Col flex="none" className="home__searching--hero-search-col">
            <ButtonSearchHotelsSkeleton size={fieldSize} />
          </Col>
        </Row>
      </div>
    )
  }

  return (
    <Row
      wrap={false}
      gutter={[12, 0]}
      align="stretch"
      className="home__searching--hotel-search-row"
      style={{ marginBlock: '2rem' }}
    >
      <Col flex="1.15 1 14rem">
        <SelectDestinationSkeleton size={fieldSize} />
      </Col>
      <Col flex="1.65 1 18rem">
        <SelectCheckInOutSkeleton size={fieldSize} />
      </Col>
      <Col flex="1 1 12rem">
        <SelectRoomAndPeopleSkeleton size={fieldSize} />
      </Col>
      <Col flex="none">
        <ButtonSearchHotelsSkeleton size={fieldSize} />
      </Col>
    </Row>
  );
}

export default SearchingHotelsSkeleton;
